import {useState} from 'react';
import PaymentByUserTable from './PaymentByUserTable';
import PaymentByUserHeader from './PaymentByUserHeader';

const PaymentByUserScreen = ({selectedYear,selectedPeriod,selectedUser}) => {
  const [search, setSearch] = useState("");
  return (
    <div>
      <PaymentByUserHeader selectedYear={selectedYear} selectedPeriod={selectedPeriod} selectedUser={selectedUser} search={search} setSearch={setSearch}/>
      <PaymentByUserTable selectedYear={selectedYear} selectedPeriod={selectedPeriod} selectedUser={selectedUser} search={search}/>
    </div>
  );
}

export default PaymentByUserScreen;